import axios from 'axios';
import { store } from '../store';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

const { dispatch } = store;

api.interceptors.request.use(async config => {
    let token = null;
    let filialSelecionada: string | null = null;
    const locaSmartPro = localStorage.getItem('persist:locasmartpro');

    // Token E filial lidos da MESMA fonte síncrona (localStorage). Não usar store.getState()
    // para a filial: no boot, o redux-persist ainda não reidratou o estado, então getState()
    // devolveria filial nula e as PRIMEIRAS requisições sairiam sem o header X-Filial-Id
    // enquanto as seguintes sairiam com ele — inconsistência de dados na mesma tela.
    if (locaSmartPro) {
        try {
            const persistido = JSON.parse(locaSmartPro);
            if (persistido.token) token = persistido.token.replaceAll('"', '');
            if (persistido.filialSelecionada) {
                const fid = persistido.filialSelecionada.replaceAll('"', '');
                filialSelecionada = (fid && fid !== 'null') ? fid : null;
            }
        } catch { /* persistência ausente/corrompida: segue sem filial (comportamento sem-filial) */ }
    }

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Só envia X-Filial-Estrita JUNTO com X-Filial-Id. Selecionar uma filial é exclusivo:
    // oculta registros sem filial (IdFilial nulo). Estrita sem id seria ambíguo e poderia
    // ocultar todos os registros — para usuários de associação estrita sem seleção, o
    // FilialValidationMiddleware injeta a filial e força o modo estrito no servidor.
    if (filialSelecionada) {
        config.headers['X-Filial-Id'] = filialSelecionada;
        config.headers['X-Filial-Estrita'] = 'true';
    }

    return config;
});

api.interceptors.response.use(response => {
    const licenseStatus = response.headers['x-license-status'];
    const daysOverdue = response.headers['x-days-overdue'];
    const contingencyRemaining = response.headers['x-contingency-remaining'];
    const overdueInvoices = response.headers['x-overdue-invoices'];

    if (licenseStatus === 'Contingency') {
        dispatch({
            type: 'SET_CONTINGENCIA',
            emContingencia: true,
            diasAtrasados: parseInt(daysOverdue || '0', 10),
            diasRestantesContingencia: parseInt(contingencyRemaining || '0', 10),
            faturasEmAtraso: parseInt(overdueInvoices || '1', 10),
        });
    } else if (licenseStatus && licenseStatus !== 'Contingency') {
        dispatch({
            type: 'SET_CONTINGENCIA',
            emContingencia: false,
            diasAtrasados: 0,
            diasRestantesContingencia: 0,
            faturasEmAtraso: 0,
        });
        dispatch({ type: 'SET_BLOQUEADO_INADIMPLENCIA', bloqueado: false });
    }

    return response;
}, error => {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                if(!error.config.url.includes('/Login/Authenticate')) {
                    dispatch({ type: 'LOG_OUT_EXPIRED' });
                }
                break;
            case 403:
                if (error.response.data?.reason === 'PAYMENT_OVERDUE_BLOCKED') {
                    dispatch({ type: 'SET_BLOQUEADO_INADIMPLENCIA', bloqueado: true });
                } else {
                    error.response.data = { Mensagem: 'Usuário logado não tem permissão para realizar essa ação.' };
                }
                break;
            default:
                break;
        }
    }

    return Promise.reject(error);
});

export default api;